var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M510.632,181.469c-9.274-31.534-54.288-17.473-77.889-14.844c-16.69,1.858-32.964,9.54-35.239-6.683 c-5.564-39.672-5.918-74.378-38.945-110.15c-22.254-24.101-47.882-1.184-38.944,16.69c18.548,50.071,12.371,90.874-63.616,90.874 c-75.987,0-82.164-40.803-63.616-90.874c8.937-17.874-16.69-40.791-38.944-16.69c-33.028,35.772-33.381,70.478-38.944,110.15 c-2.276,16.223-18.548,8.541-35.239,6.683c-23.601-2.629-68.614-16.69-77.888,14.844c-8.709,29.61,24.112,79.736,100.142,90.862 c11.127,7.422,5.563,200.285,154.489,200.285c148.927,0,143.363-192.863,154.49-200.285 C486.52,261.205,519.341,211.079,510.632,181.469z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeef);
export default __webpack_public_path__ + "static/media/beef.0a3ad131e732ba3c2cf1dcc48c77f40b.svg";
export { ForwardRef as ReactComponent };